import { useReadEpisodePlayerBaseInfo } from '../../../hooks/use-read-episode-player-base-info';
import { getEpisodeTvSeries } from '../../../utils/get-episode-tv-series';

export const useEpisodeTvSeriesContentId = (contentId: string) => {
    const episode = useReadEpisodePlayerBaseInfo(contentId);
    return (episode && getEpisodeTvSeries(episode)?.contentId) ?? '';
};
